import React from 'react';
import { Box, Typography } from '@mui/material';
import type { BaseFieldProps } from './types';

/**
 * Display text field component
 * Only available in form-builder format
 * This is not an input field, just displays static text/instructions
 */
export const DisplayTextField: React.FC<BaseFieldProps> = ({
  field,
  mode = 'edit',
  sx,
}) => {
  // Extract content - for display_text fields, the content is in the label
  const content = 'content' in field && field.content ? field.content : 
                  'label' in field ? field.label : '';
  const variant = 'variant' in field && field.variant ? field.variant : 'body1';

  // Display text fields don't need different modes - they always just display
  return (
    <Box sx={{ mb: 2, ...sx }}>
      <Typography 
        variant={variant as 'body1' | 'body2' | 'caption'}
        color="text.secondary"
      >
        {content}
      </Typography>
    </Box>
  );
};